// extracted by mini-css-extract-plugin
export default {"headerModal":"Modal_headerModal__aaBnf","modalTitle":"Modal_modalTitle__zOBF5","closeButton":"Modal_closeButton__OgEa0"};